import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared/types';
import { useTranslation } from 'react-i18next';

export function UpdateTermineSubmitButton({
  form,
  isMobile,
}: UpdateTermineFormProps) {
  const { t } = useTranslation();

  return (
    <form.AppForm>
      {isMobile ? (
        <form.SubmitButton
          buttonText={t('domain.termine.form.fertig')}
          variant="ghost-primary"
          size="sm"
        />
      ) : (
        <form.SubmitButton
          buttonText={t('domain.termine.form.fertig')}></form.SubmitButton>
      )}
    </form.AppForm>
  );
}
